import React from 'react'
import { Box, LinearProgress, Typography } from '@mui/material'

interface QuotaProgressRowProps {
  label: string
  current: number
  quota: number
}

export const QuotaProgressRow: React.FC<QuotaProgressRowProps> = ({ label, current, quota }) => {
  const percent = quota > 0 ? Math.min(100, (current / quota) * 100) : 0
  const complete = quota > 0 && current >= quota

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 1,
          mb: 0.5,
        }}
      >
        <Typography variant="body2">
          {label}:{' '}
          <Typography component="span" variant="body2" fontWeight={600} color="primary.main">
            {current}
          </Typography>
          {' / '}
          {quota}
        </Typography>
        {complete && (
          <Typography variant="caption" color="success.main">
            Quota reached
          </Typography>
        )}
      </Box>
      <LinearProgress
        variant="determinate"
        value={percent}
        color={complete ? 'success' : 'primary'}
        sx={{
          height: 8,
          borderRadius: 1,
          backgroundColor: 'action.hover',
          '& .MuiLinearProgress-bar': { borderRadius: 1 },
        }}
      />
    </Box>
  )
}

export default QuotaProgressRow
